<template>
  <section id="newsletter-signup" v-if="site.newsletterLabel">
    <div class="newsletter-signup__wrapper">
      <div class="newsletter-signup__messaging">
        <h2 class="newsletter-signup__title">{{ site.newsletterLabel }}</h2>
        <p class="newsletter-signup__content">{{ site.newsletterText }}</p>
      </div>
      <form
        class="newsletter-signup__form"
        method="GET"
        :action="newsletterSignupUrl"
      >
        <label class="sr-only" for="newsletter-signup-email">{{
          $t("newsletter.placeholder")
        }}</label>
        <input
          type="email"
          id="newsletter-signup-email"
          name="Email"
          :placeholder="$t('newsletter.placeholder')"
        />
        <button class="newsletter-signup__submit" type="submit">
          {{ $t("newsletter.button") }}
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "newsletter-block",
  computed: {
    newsletterSignupUrl() {
      return (
        process.env.VUE_APP_WK_FRONT_END_URL +
        "/" +
        this.$i18n.locale +
        "/the-authority/subscribe-to-e-newsletter"
      );
    },
    ...mapState(["site"]),
  },
};
</script>
